export default __webpack_public_path__ + "static/media/ic_contact.8632ba42.svg";